import React from 'react'
import Button from '@/components/Button'
import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { IPropsInfo } from '../interfaces'
import style from '../styles/quiz.module.scss'

const QuizInfo = ({
  detailText = '',
  title = '',
  image = '',
  onClickStart = () => {}
}: IPropsInfo): React.ReactElement => {
  return (
    <Container>
      <Section className={style.quiz_flex}>
        <img
          src={image}
          width='705px'
          height='705px'
          alt='Превью викторины'
          className={style.quiz__preview}
        />
        <div className={style.quiz_content}>
          <Title type='h2' theme='h1' className={style.quiz__title}>
            {title}
          </Title>

          {detailText !== ''
            ? (
              <p className={style.quiz__description}>{detailText}</p>
              )
            : null}

          {/* <p className={style.quiz__tagline}>
            Пройди тест и узнай свой уровень экологической грамотности!
          </p> */}

          <Button onClick={onClickStart} size='large' wide highlight>
            Начать тест
          </Button>
        </div>
      </Section>
    </Container>
  )
}

export default QuizInfo
